export default __webpack_public_path__ + "static/media/background.f3ae157a.mp3";